import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const HeroSection = () => {
  return (
    <>
      {/* Hero Section */}
      <Box className="whitepaper-hero">
        <Container maxWidth="lg">
          <Typography variant="h1" className="whitepaper-hero-title">
            Building a Modern<br />Security Data Fabric
          </Typography>
          <Typography variant="h4" className="whitepaper-hero-subtitle">
            Optimizing SIEM Costs and Performance with Confluent Platform
          </Typography>
          <Box className="whitepaper-hero-stats">
            <Box className="hero-stat">
              <Typography variant="h2">40-70%</Typography>
              <Typography>Cost Reduction</Typography>
            </Box>
            <Box className="hero-stat">
              <Typography variant="h2">1M+</Typography>
              <Typography>Events/Second</Typography>
            </Box>
            <Box className="hero-stat">
              <Typography variant="h2">Zero</Typography>
              <Typography>Data Loss</Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default HeroSection;
